import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PercentBar from 'ps-components/PercentBar/PercentBar';
import classnames from 'classnames';
import { Tooltip } from 'ps-design';
import './Survey.scss';

class Survey extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    jobCount: PropTypes.number,
    percentUtilziation: PropTypes.number,
    className: PropTypes.string,
    surveyClick: PropTypes.func
  };

  render() {
    const surveyClassName = classnames({
      'db-survey': true,
      [`${this.props.className}`]: !!this.props.className
    });
    return (
      <div className={surveyClassName}>
        <div className="survey__title">{this.props.name}</div>
        <div className="survey__details">
          <PercentBar className={this.props.className} percentage={this.props.percentUtilziation} />
          <div className="survey__details--counts">
            <Tooltip
              className="survey__details--jobs"
              display="underline"
              hoverText="The number of jobs in the survey."
              id="survey__details--jobs"
              position="bottom"
              tooltipText={`${this.props.jobCount} Jobs`}
            />
            &nbsp;/&nbsp;
            <Tooltip
              className="survey__details--percentage"
              display="underline"
              hoverText="The percent of survey jobs used in pricing."
              id="survey__details--percentage"
              position="bottom"
              tooltipText={`${this.props.percentUtilziation}%`}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Survey;
